<div
  role="dialog"
  aria-labelledby="modalAddEditContactTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        @if (step === 0) {
        <h4 class="modal-title" id="modalAddEditContactTitle">
          {{ isNew ? ('attendance.contactEdit.add' | translate) : ('attendance.contactEdit.edit' | translate) }} {{ 'attendance.contactEdit.contact' | translate }}
        </h4>
        } @else if (step !== 0) {
        <h4 class="modal-title" id="modalAddEditContactTitle">
          {{ 'attendance.contactEdit.openAttendanceConfirmation' | translate }}
        </h4>
        }
        <button
          type="button"
          class="btn-close"
          [mat-dialog-close]="true"
          aria-hidden="true"
        ></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        @if (step === 0) {
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label class="form-label">
                {{ 'attendance.contactEdit.name' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                type="text"
                class="form-control"
                maxlength="255"
                formControlName="name"
                [placeholder]="'attendance.contactEdit.namePlaceholder' | translate"
                required
              />
              <field-error-component
                [field]="'name'"
                [label]="'attendance.contactEdit.name' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-lg-6 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.email' | translate }}</label>
              <input
                class="form-control"
                maxlength="100"
                formControlName="email"
                [placeholder]="'attendance.contactEdit.emailPlaceholder' | translate"
              />
              <field-error-component
                [field]="'email'"
                [label]="'attendance.contactEdit.email' | translate"
                [formGroup]="formGroup"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3 mb-3">
              <label class="form-label">
                {{ 'attendance.contactEdit.country' | translate }} <span class="text-danger">*</span>
              </label>
              <select
                class="form-control"
                (change)="onCountryChange($event)"
                formControlName="country"
              >
                <option [value]="null" selected>{{ 'attendance.contactEdit.select' | translate }}</option>
                @for (country of countries; track $index) {
                <option [value]="country.code">
                  {{
                    selectedCountryCode === country.code
                      ? country.flag + " " + country.code
                      : country.name
                  }}
                </option>
                }
              </select>
              <field-error-component
                [field]="'country'"
                [label]="'attendance.contactEdit.country' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-lg-4 mb-3">
              <label class="form-label">
                {{ 'attendance.contactEdit.phone' | translate }}
                <span class="text-danger">*</span>
              </label>
              <input
                (keypress)="keyPressOnlyNumbers($event)"
                class="form-control"
                maxlength="25"
                formControlName="phone"
                placeholder="000000000"
                [mask]="phoneMask"
                required
              />
              <field-error-component
                [field]="'phone'"
                [label]="'attendance.contactEdit.phone' | translate"
                [formGroup]="formGroup"
              />
            </div>
            <div class="col-lg-3 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.tin' | translate }}</label>
              <input
                class="form-control"
                maxlength="100"
                formControlName="tin"
                [mask]="'000.000.000-00'"
                placeholder="000.000.000-00"
              />
            </div>
            <div class="col-lg-2 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.gender' | translate }}</label>
              <mat-select class="form-control" formControlName="gender">
                @for (gender of listGenders; track gender) {
                <mat-option [value]="gender">
                  {{
                    gender === "MALE"
                      ? ('attendance.contactEdit.genderMale' | translate)
                      : gender === "FEMALE"
                      ? ('attendance.contactEdit.genderFemale' | translate)
                      : ('attendance.contactEdit.genderOther' | translate)
                  }}
                </mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div class="row">
            <div
              class="col-lg-4 mb-2 trend-datepicker flex-column"
              (click)="picker.open()"
              tabindex="0"
              role="button"
            >
              <label class="form-label">{{ 'attendance.contactEdit.birthDate' | translate }}</label>
              <div class="d-flex">
                <input
                  class="form-control"
                  [matDatepicker]="picker"
                  formControlName="birthDate"
                  [readonly]="true"
                  (keydown)="$event.preventDefault()"
                  (focus)="picker.open()"
                  [placeholder]="'attendance.contactEdit.datePlaceholder' | translate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </div>
            </div>
            <div class="col-lg-4 mb-2">
              <label class="form-label">{{ 'attendance.contactEdit.company' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="contactCompany"
                [placeholder]="'attendance.contactEdit.companyPlaceholder' | translate"
              />
            </div>
            <div class="col-lg-4 mb-2">
              <label class="form-label">{{ 'attendance.contactEdit.position' | translate }}</label>
              <input
                type="text"
                class="form-control"
                formControlName="contactPosition"
                [placeholder]="'attendance.contactEdit.positionPlaceholder' | translate"
              />
            </div>
          </div>
          <div class="row my-3">
            <h5>{{ 'attendance.contactEdit.otherInformation' | translate }}</h5>
          </div>
          <div class="row">
            <div class="col-lg-4 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.zip' | translate }}</label>
              <input
                [mask]="'00.000-000'"
                class="form-control"
                formControlName="zip"
                [placeholder]="'attendance.contactEdit.zipPlaceholder' | translate"
                (ngModelChange)="onCep($event)"
              />
            </div>
            <div class="col-lg-8 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.address' | translate }}</label>
              <input class="form-control" formControlName="address" />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-10 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.city' | translate }}</label>
              <input class="form-control" formControlName="city" />
            </div>
            <div class="col-lg-2 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.state' | translate }}</label>
              <input
                class="form-control"
                maxlength="2"
                formControlName="state"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.groups' | translate }}</label>
              <mat-select
                class="form-control"
                formControlName="groups"
                multiple
                [placeholder]="'attendance.contactEdit.select' | translate"
              >
                <input
                  class="input-select-filter form-control"
                  type="text"
                  (focus)="onFocusGroup()"
                  [formControl]="filterControlGroup"
                  [placeholder]="'attendance.contactEdit.searchGroup' | translate"
                />
                @for (item of allGroups; track item) {
                <mat-option [value]="item._id">{{ item.name }}</mat-option>
                }
              </mat-select>
            </div>
            <div class="col-lg-6 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.tags' | translate }}</label>
              <mat-select class="form-control" formControlName="tags" multiple>
                <input
                  class="input-select-filter form-control"
                  type="text"
                  (focus)="onFocusTags()"
                  [formControl]="filterControlTags"
                />
                @for (item of allTags; track item) {
                <mat-option [value]="item._id">{{ item.title }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mb-3">
              <label class="form-label">{{ 'attendance.contactEdit.customFields' | translate }}</label>
              <mat-select
                class="form-control"
                formControlName="selectedFields"
                (selectionChange)="updateCustomFields($event.value)"
                multiple
              >
                <input
                  class="input-select-filter form-control"
                  type="text"
                  (focus)="onFocusCustomFields()"
                  [formControl]="filterCustomField"
                />
                @for (item of allFieldsCustom; track item) {
                <mat-option [value]="item._id">{{ item.name }}</mat-option>
                }
              </mat-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mb-3">
              <div formArrayName="customFields">
                @for(field of customFields.controls; track $index) {
                  <div [formGroupName]="$index">
                    @switch (getFieldType(field.get('_id').value)) {
                      @case('TEXT') {
                        <div class="mb-3">
                          <label class="form-label">
                            {{ getFieldName(field.get('_id').value) }}
                          </label>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="value"
                          />
                        </div>
                      }
                      @case('NUMBER') {
                        <div class="mb-3">
                          <label class="form-label">
                            {{ getFieldName(field.get("_id").value) }}
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            formControlName="value"
                          />
                        </div>
                      }
                      @case('FREETEXT') {
                        <div class="mb-3">
                          <label class="form-label">
                            {{ getFieldName(field.get("_id").value) }}
                          </label>
                          <textarea
                            class="form-control"
                            style="width: 100%; resize: none; outline: none"
                            maxlength="320"
                            formControlName="value"
                          ></textarea>
                        </div>
                      }
                      @case('DATE') {
                        <div class="mb-3">
                          <label class="form-label">
                            {{ getFieldName(field.get("_id").value) }}
                          </label>
                          <div class="d-flex trend-datepicker">
                            <input
                              class="form-control"
                              [matDatepicker]="fieldsPicker"
                              formControlName="value"
                              [readonly]="true"
                              (keydown)="$event.preventDefault()"
                              (focus)="fieldsPicker.open()"
                              [placeholder]="'attendance.contactEdit.datePlaceholder' | translate"
                            />
                            <mat-datepicker-toggle
                              matIconSuffix
                              [for]="fieldsPicker"
                            ></mat-datepicker-toggle>
                            <mat-datepicker #fieldsPicker></mat-datepicker>
                          </div>
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </form>
        } @else if (step !== 0){
        <p class="text-muted fw-normal mb-0">
          {{ 'attendance.contactEdit.openAttendanceHint' | translate }}
        </p>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="close()">
          {{ 'attendance.contactEdit.cancel' | translate }}
        </button>

        @if (step === 0) {
        <button type="button" class="btn btn-primary" (click)="save()">
          {{ !loading ? (isNew ? ('attendance.contactEdit.save' | translate) : ('attendance.contactEdit.edit' | translate)) : "" }}

          @if(loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
          }
        </button>
        } @else if (step !== 0) {
        <button
          type="button"
          class="btn btn-primary"
          (click)="newConversation()"
        >
          {{ 'attendance.contactEdit.openAttendance' | translate }} @if(loading) {
          <mat-spinner
            [diameter]="25"
            [color]="'accent'"
            mode="indeterminate"
          />
          }
        </button>
        }
      </div>
    </div>
  </div>
</div>
